module.exports = __webpack_public_path__ + "img/功能映射.7e18803e.svg";